import React from 'react';
import config from '../../config';
import { HTMLTrans } from '../Common/Translations';

const RedeemVoucher = () => (
  <div className='col-sm-12'>
    <div className='container redeem-voucher__footer'>
      <div className='row'>
        <div className='col-12'>
          <div className='d-flex justify-content-center redeem-voucher__title'>
            <HTMLTrans id="promotion.redeemvoucher_title">Redeem Voucher in 3 EASY STEPS!</HTMLTrans>
          </div>
        </div>
      </div>
      <div className='row mt-5'>
        <div className='col-sm-4 redeem-voucher__container'>
          <div className='text-center'>
            <img className='redeem-voucher__image img-fluid' src={`${config.s3BucketUrl}/prepaid/steps/buy-voucher.jpg`}/>
          </div>
          <div className='text-center mt-3'>
            <h5 className='ProximaNova-Bold mb-0'><HTMLTrans id="promotion.redeemvoucher_step1_title">Step 1</HTMLTrans></h5>
          </div>
          <div className='text-center mt-2'>
            <h6><HTMLTrans id="promotion.redeemvoucher_step1_desc">BUY NOW and receive a Voucher Code</HTMLTrans></h6>
          </div>
        </div>
        <div className='col-sm-4 redeem-voucher__container'>
          <div className='text-center'>
            <img className='redeem-voucher__image img-fluid' src={`${config.s3BucketUrl}/prepaid/steps/create-product.jpg`}/>
          </div>
          <div className='text-center mt-3'>
            <h5 className='ProximaNova-Bold mb-0'><HTMLTrans id="promotion.redeemvoucher_step2_title">Step 2</HTMLTrans></h5>
          </div>
          <div className='text-center mt-2'>
            <h6><HTMLTrans id="promotion.redeemvoucher_step2_desc">CREATE photo product before voucher expiry date</HTMLTrans></h6>
          </div>
        </div>
        <div className='col-sm-4 redeem-voucher__container'>
          <div className='text-center'>
            <img className='redeem-voucher__image img-fluid' src={`${config.s3BucketUrl}/prepaid/steps/use-voucher.jpg`}/>
          </div>
          <div className='text-center mt-3'>
            <h5 className='ProximaNova-Bold mb-0'><HTMLTrans id="promotion.redeemvoucher_step3_title">Step 3</HTMLTrans></h5>
          </div>
          <div className='text-center mt-2'>
            <h6><HTMLTrans id="promotion.redeemvoucher_step3_desc">CHECK OUT using voucher code and receive product within 7 working days</HTMLTrans></h6>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default RedeemVoucher;



// WEBPACK FOOTER //
// ./src/Promotion/RedeemVoucher.js